import type { ReactNode } from "react"

import { parseAlgoliaHitHighlight } from "@algolia/autocomplete-preset-algolia"
import { createElement, Fragment } from "react"

import { RichTextFromHtml } from "@/modules/kontent/components/RichTextFromHtml"

type HighlightHitParams<THit> = {
  hit: THit
  attribute: keyof THit | string[]
  tagName?: string
}

export const Highlight = <THit extends { _highlightResult?: object | undefined }>({
  hit,
  attribute,
  tagName = "mark",
}: HighlightHitParams<THit>): ReactNode => {
  return createElement(
    Fragment,
    null,
    parseAlgoliaHitHighlight<THit>({ attribute, hit }).map(({ value, isHighlighted }, index) => {
      if (isHighlighted) {
        // eslint-disable-next-line react/no-array-index-key
        return createElement(tagName, { key: index }, value)
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/no-array-index-key
      return <RichTextFromHtml key={index} wrapperProps={{ as: "span" } as any} html={value} />
    })
  )
}
